import React from 'react';
import SignUpConfirmStep from './SignUpConfirmStep';
import SignUpStepProgressLayout from '../../Layout/SignUpStepProgressLayout';

function SignUpConfirmStepDesktop() {
  return (
    <SignUpStepProgressLayout step={2}>
      <SignUpConfirmStep/>
    </SignUpStepProgressLayout>
  )
}

export default SignUpConfirmStepDesktop